module.exports = __webpack_public_path__ + "img/kayla.4e88d5d7.jpeg";